import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { UserInvitation, Workspace } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0470. ワークスペース招待中ユーザ一覧
 * [GET] /workspaces/:identifier/user_invitations
 */
const user_invitations = (identifier: string): Promise<UserInvitation[]> => {
  return axios.get(`/api/workspaces/${identifier}/user_invitations`);
};

export const useUserInvitations = (identifier: string) => {
  return useQuery({
    queryKey: ['workspaces', identifier, 'user_invitations'],
    queryFn: () => user_invitations(identifier),
  });
};

export const useUserInvitationsInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'user_invitations'] });
  };

  return { invalidate };
};
